// @flow
import styled, { css } from 'styled-components';
import DefaultTheme from '.';
import { errorText, se300 } from '../../colors';
/*::
  import type { FormElementThemeType } from '..';
*/

var theme = Object.assign({}, DefaultTheme, {
  Label: styled(DefaultTheme.Label).withConfig({
    displayName: "shipa-ecommerce__Label",
    componentId: "dr8asw-0"
  })(["", ""], function (pr) {
    return pr.focused ? css(["color:", ";"], pr.error ? errorText() : se300()) : '';
  }),
  Required: styled(DefaultTheme.Required).withConfig({
    displayName: "shipa-ecommerce__Required",
    componentId: "dr8asw-1"
  })(["color:", ";"], se300())
});
export default theme;